export default "__VITE_ASSET__BiHLJdXf__"